import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

export default function pageToggle() {
	const internalNav = document.querySelector('.page-toggle-section');
	if( !internalNav ) return;

	gsap.registerPlugin(ScrollTrigger);
	gsap.registerPlugin(ScrollToPlugin);

	ScrollTrigger.create({
		trigger: internalNav,
		endTrigger: document.querySelector('body'),
		start: () => {
			let topMenu = document.querySelector('header.header');
			return `top top+=${topMenu.offsetHeight}`
		},
		end: 'bottom top',
		fastScrollEnd: true,
		//markers: {startColor: "purple", endColor: "purple", fontSize: "18px", fontWeight: "bold", indent: 20},
		pin: true,
		pinSpacing: false,
		toggleClass: { targets: internalNav, className: 'scrolled' },
		invalidateOnRefresh: true,
	});
	



	let filters = [];
	var navUpdate = function(anchor){
		const sections = document.querySelectorAll('section');
		sections.forEach((section) => {
			
			let matched = true;
			let sectionFilter = section.dataset.filterFilter;
			if(sectionFilter !== undefined && sectionFilter != "" && anchor != ""){
				//section has a filter and anchor is defined. default to hidding and show if matches
				matched = false;
				if(sectionFilter.indexOf("{"+anchor+"}") > -1){
					matched = true;
				}
			}
			if(!matched){
				section.classList.add('is-hidden');
			}else{
				section.classList.remove('is-hidden');
			}

		});
		const params = new URLSearchParams(window.location.search);
		params.set('filter', anchor);
		window.history.pushState({}, '', `${window.location.pathname}?${params.toString()}`);

		//if also using a nav anchor link section remove items that are not on the page
		let navAnchorLinks = document.querySelectorAll('.nav-anchorlinks-section a');
		navAnchorLinks.forEach((item) => {
			let href = item.getAttribute('href');
			if(href != "" && href[0] == "#"){
				let sectionId = href.slice(1);
				let section = document.getElementById(sectionId);
				if(!section || section.classList.contains('is-hidden')){
					item.classList.add('is-hidden');
				}else{
					item.classList.remove('is-hidden');
				}
			}
		});
	}

	let doDefault = true;
	let defaultFilter = '';
	const searchParams = new URLSearchParams(window.location.search);
	if (searchParams.has('filter')) {
		doDefault = false;
		defaultFilter = searchParams.get('filter');
	}


	const items = internalNav.querySelectorAll('.items a');
	
	items.forEach((item) => {
		let href = item.getAttribute('href');
		let hashPos = href.indexOf('#');
		if (hashPos > -1) {
			let anchor = href.substring(hashPos+1);
			filters.push(anchor);
		}

		item.addEventListener('click', (event) => {
			event.preventDefault();
			let anchor = item.getAttribute('href').substring(1);
			navUpdate(anchor);
			
			items.forEach((item) => {
				if (item.getAttribute('href') !== event.currentTarget.getAttribute('href')) {
					item.classList.remove('active');
				} else {
					item.classList.add('active');
				}
			});
			window.dispatchEvent(new CustomEvent('pageToggleResize'));
		});

		//show the one the admin has pre-selected as active
		if((doDefault && item.getAttribute('data-default') == "true") || !doDefault && defaultFilter == item.getAttribute('href').substring(1)){
			item.click();
		}
	});



}

